import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
const termsContent = `
Términos y Condiciones

Última actualización: Mayo 2026

1. Aceptación de los Términos
Al adquirir y utilizar el producto digital "Sintonía Total: El Manual de Conexión (0-5 años)", aceptas estos términos y condiciones en su totalidad.

2. Producto Digital
"Sintonía Total" es un producto digital en formato PDF de acceso inmediato. No se realizan envíos físicos. Una vez completada la compra, recibirás acceso al material de forma instantánea.

3. Uso Personal
El contenido de este manual es para uso personal y exclusivo del comprador. Queda prohibida la reproducción, distribución, modificación o reventa total o parcial del material sin autorización expresa por escrito.

4. Propiedad Intelectual
Todo el contenido del manual, incluyendo textos, gráficos, guiones y metodologías, está protegido por derechos de autor. La compra otorga una licencia de uso personal, no transferible.

5. Política de Reembolso
Debido a la naturaleza digital del producto y su entrega inmediata, no se aceptan devoluciones ni reembolsos una vez completada la descarga.

6. Limitación de Responsabilidad
El contenido de "Sintonía Total" tiene fines educativos e informativos. No sustituye el consejo médico, psicológico o terapéutico profesional. El uso del material es responsabilidad exclusiva del comprador.

7. Modificaciones
Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones serán efectivas desde su publicación.
`.trim();
const privacyContent = `
Política de Privacidad

Última actualización: Mayo 2026

1. Información que Recopilamos
Al realizar tu compra, recopilamos únicamente la información necesaria para procesar tu pedido: nombre, dirección de correo electrónico y datos de pago (procesados de forma segura por nuestro proveedor de pagos).

2. Uso de la Información
Tu información personal se utiliza exclusivamente para:
- Procesar y entregar tu compra digital.
- Enviarte el acceso al producto adquirido.
- Comunicaciones relacionadas con tu compra.

3. Protección de Datos
Implementamos medidas de seguridad técnicas y organizativas para proteger tu información personal contra acceso no autorizado, alteración o destrucción.

4. No Compartimos tu Información
No vendemos, alquilamos ni compartimos tu información personal con terceros, excepto cuando sea necesario para procesar tu pago de forma segura.

5. Cookies
Nuestro sitio puede utilizar cookies esenciales para el funcionamiento básico de la página y el proceso de compra.

6. Tus Derechos
Tienes derecho a acceder, rectificar o solicitar la eliminación de tus datos personales en cualquier momento escribiéndonos directamente.

7. Menores de Edad
Este producto está dirigido a adultos (madres, padres y cuidadores). No recopilamos intencionalmente información de menores de edad.

8. Cambios en esta Política
Nos reservamos el derecho de actualizar esta política. Cualquier cambio será publicado en esta página con la fecha de actualización correspondiente.
`.trim();
interface ModalProps {
  title: string;
  content: string;
  onClose: () => void;
}
function LegalModal({
  title,
  content,
  onClose
}: ModalProps) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-brown/60 backdrop-blur-sm" onClick={onClose} data-id="element-26">
      <div className="bg-cream rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] flex flex-col overflow-hidden border border-cream-dark" onClick={e => e.stopPropagation()} data-id="element-27">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-cream-dark" data-id="element-28">
          <h3 className="text-xl font-bold text-brown font-serif" data-id="element-29">{title}</h3>
          <button onClick={onClose} className="w-9 h-9 rounded-full bg-brown/5 hover:bg-brown/10 flex items-center justify-center transition-colors" data-id="element-30">
            <XIcon className="w-5 h-5 text-brown" data-id="element-31" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-6 overflow-y-auto" data-id="element-32">
          <div className="text-brown-light leading-relaxed whitespace-pre-line text-sm" data-id="element-33">
            {content}
          </div>
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<'terms' | 'privacy' | null>(null);
  return <>
      <footer className="bg-brown text-cream/70 py-12 text-center text-sm" data-id="element-34">
        <div className="max-w-4xl mx-auto px-6" data-id="element-35">
          <p className="mb-4 font-serif text-xl text-cream" data-id="element-36">Sintonía Total</p>
          <p data-id="element-37">
            © {new Date().getFullYear()} Sintonía Total. Todos los derechos
            reservados.
          </p>
          <div className="mt-6 flex justify-center gap-6 text-xs opacity-60" data-id="element-38">
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors underline-offset-2 hover:underline cursor-pointer" data-id="element-39">
              Términos y Condiciones
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors underline-offset-2 hover:underline cursor-pointer" data-id="element-40">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      {activeModal === 'terms' && <LegalModal title="Términos y Condiciones" content={termsContent} onClose={() => setActiveModal(null)} data-id="element-41" />}
      {activeModal === 'privacy' && <LegalModal title="Política de Privacidad" content={privacyContent} onClose={() => setActiveModal(null)} data-id="element-42" />}
    </>;
}